import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "my-8"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.cartHasItems)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("a", {
          class: "btn btn-primary btn-small btn-lock__before w-full",
          href: "/checkout",
          onClick: _cache[0] || (_cache[0] = (...args) => ($options.handleCheckout && $options.handleCheckout(...args)))
        }, _toDisplayString($props.locale.to_checkout), 1)
      ]))
    : _createCommentVNode("", true)
}